import React, { useState } from "react";
import { CancelIcon } from "../../../icon";
import { Dialog, DialogContent, DialogTitle, FormHelperText, Grid, TextField, Tooltip } from "@mui/material";
import ButtonComponent from "../../shared/button/button.component";
import { buttonLabels } from "../../shared/constants";
import { validateForm } from "../../shared/form-validation";
import { ChannelService } from "../../../services/channels/ChannelAcountService";
import { ChannelUserModel } from "../../../models/users.model";
import { ChannelUserService } from "../../../services/ChannelUserService";


interface Props {
    ViewOrganization: boolean;
    handleClose: (refresh: boolean) => void;
    SelectedOrganizationId: string,
    IsEdit: boolean,
    Org_Details: { Name: string, Email: string }
}


const AddChannelOrganization: React.FC<Props> = (props: Props) => {

    const [orgDetails, setOrgDetails] = useState<{ Name: string, Email: string }>({ Name: props.Org_Details.Name, Email: props.Org_Details.Email });
    const [errors, setErrors] = useState<{ Name: string, Email: string }>({ Name: "", Email: "" });
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const CurrentUser: ChannelUserModel = ChannelUserService.getCurrentUserFromLocalStorage();


    const handleChange = (name: any, value: any) => {
        validateForm({ [name]: value },
            (Errors) => {
                setErrors({ ...errors, ...Errors })
            })
        const details = { ...orgDetails, [name]: value }
        setOrgDetails({ ...details })
    };

    const EditOrg = () => {
        setIsLoading(true)
        ChannelService.EditChannelOrganisation(props.SelectedOrganizationId,{name:orgDetails.Name,email:orgDetails.Email,plan_type:0,status:1}).then(res=>{
            setIsLoading(false)
            props.handleClose(true)
        })
    }

    const AddOrg = () => {
        setIsLoading(true)
        ChannelService.addChannelOrganisation({name:orgDetails.Name,email:orgDetails.Email,plan_type:0,status:1,added_by:CurrentUser.ID}).then(res=>{
            setIsLoading(false)
            props.handleClose(true)
        })
    }

    return (
        <>
            <Dialog
                maxWidth="sm"
                fullWidth={true}
                onClose={props.handleClose}
                aria-labelledby="customized-dialog-title"
                BackdropProps={{ style: { backgroundColor: "transparent" } }}
                open={props.ViewOrganization}

                disableEscapeKeyDown
                classes={{ paper: "br-2 dialogue-shadow w-70" }}>
                <DialogTitle className="dialog-header" id="customized-dialog-title">
                    <div className="h2-regular color-display-title d-flex" id="customized-dialog-title">
                        {props.IsEdit ? "Edit Organization" : "Add Organization"}
                        <Tooltip title='Close' placement='bottom'>
                            <span className={"ml-auto"}><CancelIcon className={"c-pointer ml-auto"} onClick={() => props.handleClose(false)} /></span></Tooltip>
                    </div>
                </DialogTitle>
                <DialogContent className="ox-hidden">
                    <Grid container direction="column" spacing={2}>
                        <Grid item xs={6} className="mt-2">
                            <TextField autoFocus
                                name="Name"
                                placeholder="Name"
                                label="Organization Name"
                                size="small"
                                required
                                fullWidth
                                variant="outlined"
                                value={orgDetails.Name}
                                onChange={(e) =>
                                    handleChange(e.target.name, e.target.value)
                                }
                                InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                autoComplete='no'
                            />
                            <FormHelperText className="h5-regular color-primary-danger t-align-right h-1">
                                {errors.Name}
                            </FormHelperText>
                        </Grid>
                        <Grid item xs={6} className="">
                            <TextField
                                fullWidth
                                label="Email"
                                name="Email"
                                placeholder="Email"
                                size="small"
                                required
                                variant="outlined"
                                value={orgDetails.Email}
                                onChange={(e) =>
                                    handleChange(e.target.name, e.target.value)
                                }
                                InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                autoComplete='no'
                            />
                            <FormHelperText className="h5-regular color-primary-danger t-align-right h-2">
                                {errors.Email}
                            </FormHelperText>
                        </Grid>
                    </Grid>
                    <div className="d-flex float-right mt-1 mb-2">
                        <ButtonComponent ButtonLabel={buttonLabels.SAVE} Loading={isLoading} ClassName={"subtext c-pointer px-4 mr-1"} Variant={"primary-btn-small"} OnClick={props.IsEdit ? EditOrg : AddOrg} />
                        <ButtonComponent OnClick={() => props.handleClose(false)} ButtonLabel={buttonLabels.CANCEL} ClassName={"subtext mr-0_1 c-pointer"} Variant={"secondary-btn-small"} /></div>
                </DialogContent>
            </Dialog >
        </>
    )
}

export default AddChannelOrganization;